// extracted by mini-css-extract-plugin
export default {"cls1":"QOFRSJawpcHya5sT0G1l","cls2":"oWNsLvoZQL6q2yPrnO3W QOFRSJawpcHya5sT0G1l"};